<script setup>
    import { ref, onMounted } from 'vue';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { EffectFade, Navigation, Pagination, A11y } from 'swiper';
    import 'swiper/css';
    import 'swiper/css/navigation';
    import 'swiper/css/pagination';
    import 'swiper/css/effect-fade';

    const props   = defineProps({ slides: Object })
    const modules = [EffectFade, Navigation, Pagination, A11y]

    const speed = ref(300)

    onMounted(() => {
        if (window?.reduced_motion) {
            speed.value = 0;
        }
    })

    function onSwiper(swiper) {
        // console.log(swiper);
    }

    function onSlideChange() {
        console.log('slide change');
    }
</script>

<template>
    <div class="relative carousel-cards">
        <swiper
            :modules="modules"
            :slides-per-view="1"
            :breakpoints="{ 768: { slidesPerView: 2 }, 1200: { slidesPerView: 3 } }"
            :loop="true"
            :speed="speed"
            :navigation="{ prevEl: '.carousel-cards__prev', nextEl: '.carousel-cards__next' }"
            :pagination="{ clickable: true, el: '.carousel-cards__pagination' }"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
        >
            <swiper-slide v-for="slide in props.slides">
                <div class="slide p-3 box-border flex items-start drop-shadow-md">
                    <div class="text-center bg-white h-full rounded-xl overflow-hidden pb-6">
                        <div class="image-feature relative overflow-hidden">
                            <img class="absolute w-full h-full object-cover top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" :src="slide.image_url" :alt="slide.image_alt">
                        </div>
                        <h4 v-if="slide.title" class="px-6">{{ slide.title }}</h4>
                        <div v-if="slide.text" class="rich-text-body text-sm px-8" v-html="slide.text"></div>
                        <a v-if="slide.link" class="theme-button mt-8" :href="slide.link">{{ slide.link_text }}</a>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="carousel-cards__prev swiper-button-prev"></div>
        <div class="carousel-cards__next swiper-button-next"></div>
        <div class="carousel-cards__pagination swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal">
            <span v-for="(slide, index) in props.slides" class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide {{ index }}" aria-current="true"></span>
        </div>
    </div>
</template>
